import Vue from "vue";

export default {
    namespaced: true,
    state: {
        permissions: [],
        userInfo: null,
        accountId: null
    },
    getters: {
        getPermissions: (state) => state.permissions,
        getUserInfo: (state) => state.userInfo,
        getAccountId: (state) => state.accountId,
        hasAppAccess: (state) => {
            return state.permissions.some((p) => p.name === "mysfc" || p.name === "myconfig");
        }
    },
    mutations: {
        SET_PERMISSIONS(state, payload) {
            state.permissions = payload;
        },
        SET_USER_INFO(state, payload) {
            state.userInfo = payload;
        },
        SET_ACCOUNT_ID(state, payload) {
            state.accountId = payload;
        }
    },
    actions: {
        async fetchPermissions({ commit, state }) {
            if (state.permissions.length > 0) {
                return { permissions: state.permissions, accountId: state.accountId };
            }

            try {
                const response = await Vue.prototype.$http2.get("/api/user/permissions");
                const { permissions, sites, accountId } = response.data.data;

                commit("SET_PERMISSIONS", permissions);
                commit("SET_ACCOUNT_ID", accountId ?? null);

                const userInfo = Vue.$cookies.get("userInfo");
                if (userInfo) {
                    if (sites) userInfo.userData.sites = sites;
                    commit("SET_USER_INFO", userInfo);
                }

                return { permissions, sites, accountId };
            } catch (error) {
                console.error("[Auth] Erro ao buscar permissões:", error);
                throw error;
            }
        }
    }
};
